var _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 1,
    y: 12,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#3C6E8E"
  }, "R")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 9,
    y: 12,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#3C6E8E"
  }, "x")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 13,
    y: 12,
    fontFamily: "Arial",
    fontSize: 7,
    fill: "#3C6E8E"
  }, "only")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxIcon);
export default __webpack_public_path__ + "static/media/rx-icon.32bbbbf49ddd849820ed596b45a150bd.svg";
export { ForwardRef as ReactComponent };